import { useEffect, useState, useContext } from 'react';
import { useAPI } from '../services/api';
import Associations from '../components/Associations';
import CompanyInfo from '../components/CompanyInfo';
import AuthContext from '../store/auth-context';
import ToastContext from '../store/toast-context';
import formatPhoneNumber, { deformatPhoneNumber } from '../services/formatPhoneNumber';
import '../styles/pages/AccountDetails.scss';

const AccountDetailsPage = ({ title = 'Account Details' }) => {
  const api = useAPI();
  const auth = useContext(AuthContext);
  const { error, success } = useContext(ToastContext);
  const [companies, setCompanies] = useState([]);
  const [companyDetails, setCompanyDetails] = useState({});

  useEffect(() => {
    const getData = async () => {
      let { data } = await api.get(`/company/details/${auth.user.id}`);
      data.phone = formatPhoneNumber(data.phone.toString());
      setCompanyDetails(data);
      for (let company of data.associations) {
        company.phone = formatPhoneNumber(company.phone.toString());
      }
      setCompanies(data.associations);
    };
    getData();
  }, [api, auth.user.id]);

  const addCompany = async (values) => {
    let userBody = {
      con_name: values.name,
      mort_service_id: auth.user.id,
      contact_type: 'M',
      con_address: values.address,
      con_city: values.city,
      con_state: values.state,
      con_zipcode: parseInt(values.zip),
      con_e_mail: values.email,
      con_phone: values.phone.replaceAll('-', ''),
      valid_record: 1,
    };
    let { data } = await api.post(`/company/add-mortgage`, userBody);
    values.id = data.id;
    setCompanies((companies) => [...companies, values]);
  };

  const updateAssociationDetails = async (values) => {
    const index = companies.findIndex(({ id }) => id === values.id);
    setCompanies((companies) => [
      ...companies.slice(0, index),
      values,
      ...companies.slice(index + 1),
    ]);
    let newVals = { ...values };
    newVals.phone = deformatPhoneNumber(values.phone);
    try {
      await api.patch('company/details', newVals);
      success('Successfully updated company details');
    } catch (e) {
      error(e.message);
    }
  };

  const updateCompanyDetails = async (values) => {
    setCompanyDetails(values);
    let newVals = { ...values };
    newVals.phone = deformatPhoneNumber(values.phone);
    try {
      await api.patch('company/details', newVals);
      success('Successfully updated company details');
    } catch (e) {
      error(e.message);
    }
  };

  return (
    <>
      <h1 className="display-4 fw-normal mb-3">{title}</h1>
      <CompanyInfo initialValues={companyDetails} onSubmit={updateCompanyDetails} />
      {companyDetails.contact_type === 'S' && (
        <Associations
          type="Mortgage Companies"
          companies={companies}
          addCompany={addCompany}
          updateCompany={updateAssociationDetails}
        />
      )}
    </>
  );
};

export default AccountDetailsPage;
